import { css } from 'styled-components';

/** Quiet controls at rest; the same gradient and brightness as the guide banner on hover. */
export const workspaceButtonStyles = css`
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.bgPrimary};
  color: ${({ theme }) => theme.colors.textSecondary};
  filter: none;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease, filter 150ms ease;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.brand}, ${({ theme }) => theme.colors.brandGradientEnd});
    border-color: transparent;
    color: ${({ theme }) => theme.colors.brandContrastText};
    filter: brightness(1.06);
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.brand};
    outline-offset: 3px;
  }
  &:disabled { opacity: 0.45; cursor: not-allowed; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

export const workspaceFieldStyles = css`
  color: ${({ theme }) => theme.colors.textPrimary};
  background: ${({ theme }) => theme.colors.bgPrimary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.brandSoft};
  }
`;
